import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { TranslationService } from 'projects/dop-core/src/lib/translation/translation.service';
import { SAMPLE } from 'src/app/features/guided-order/samples/constants/sample-constants';
import { OrderDataService } from '../data-service/order-data.service';
import { SampleQuantityResponse } from '../models/required-sample-quantity/sample-quantity-response.model';
import { DownloadFileHelperService } from '../services/download-file-helper.service';
import { HelperService } from '../services/helper.service';

@Component({
  selector: 'app-sample-quantity',
  templateUrl: './sample-quantity.component.html',
  styleUrls: ['./sample-quantity.component.scss'],
  providers: [MessageService]
})
export class SampleQuantityComponent implements OnInit {

  @Input() openSQDialog = false;
  @Output() sqDialogClosed = new EventEmitter<boolean>();
  @Input() set samples(value: SampleQuantityResponse[]) {
    this.setSampleDisplayData(value);
  }
  @Input() orderCode = '';
  cols: any[] = [];
  displaySamples: SampleQuantityResponse[] = [];

  constructor(
    private orderDataService: OrderDataService,
    private messageService: MessageService,
    private helperService: HelperService,
    private downloadFileHelperService: DownloadFileHelperService,
  ) { }

  ngOnInit(): void {
    this.cols = [
      { field: 'sample', header: TranslationService.translate('vbeiSampleDetails'), width: '240' },
      { field: 'analyses', header: TranslationService.translate('vbeiAnalyses') },
      { field: 'preferredSampleContainer', header: TranslationService.translate('vbeiPreferredSampleContainer'), width: '160' },
      { field: 'minimumQuantity', header: TranslationService.translate('vbeiMinimumQuantity'), width: '92' },
      { field: 'optimumQuantity', header: TranslationService.translate('vbeiOptimumQuantity'), width: '92' }
    ];
  }

  setSampleDisplayData(samplesData: SampleQuantityResponse[]) {
    samplesData.forEach(s => {
      s.sampleQuantityDetails = s.sampleQuantityDetails?.filter(x => !x.isCPHeader);
      s.sampleQuantityDetails.sort((x, y) => {
        return (x.isMrt === y.isMrt)? (x.sequence >= y.sequence ? 1 : -1) : (x.isMrt? 1 : -1);
      });
    });
    this.displaySamples = samplesData;
  }

  closeSampleQuantityDialog() {
    this.sqDialogClosed.emit(this.openSQDialog);
  }

  exportAsPDF() {
    this.orderDataService.getRequiredSampleQuantityPDF(this.orderCode)
    .toPromise().then(x => {
      this.downloadFileHelperService.download(x, 'RequiredSampleQuantity.pdf');
    }).catch(error => {
      const errorMessage = this.helperService.handleHttpError(error, SAMPLE);
      this.showError({ detail: TranslationService.translate(errorMessage) });
    });
  }

  showError(data: { severity?: string, summary?: string, detail: string }) {
    this.messageService.add({
      key: 'requiredSampleQuantityError',
      severity: !data.severity ? 'error' : data.severity,
      summary: data.summary,
      detail: data.detail
    });
  }

  formatContent(sumOfQuantity: string[]){
    return sumOfQuantity.join('<br>');
  }

}
